module.exports = __webpack_public_path__ + "media/images/home/mini/1-a7109e0195e44dc76255622c5029f62c.png";